import {
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { getUserProperties, produceEventLog } from "../../utils/helper";
import SettingsIcon from "@mui/icons-material/Settings";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MicIcon from "@mui/icons-material/Mic";
import useTranslationSetup from "../../utils/useTranslationSetup";
import passwordIncorrectImg from "../../assets/password_incorrect_img.svg";
import nipunHrLogo from "../../assets/nipunHrLogo.svg";
import useParamValues from "../../utils/useParamValues";
import "./GrantPermissionsStepsDialog.css";

function GrantPermissionsStepsDialog({ isDialogOpen, onClick }) {
  const { t } = useTranslationSetup();
  const userProperties = getUserProperties(useParamValues());

  useEffect(() => {
    if (isDialogOpen) {
      produceEventLog("permission_no_grant_page_view", {
        ...userProperties,
      })
    }
  }, [isDialogOpen]);

  return (
    <Dialog
      className="grant-permissions-steps-dialog"
      open={isDialogOpen}
      style={{ borderRadius: "20px" }}
    >
      <DialogTitle>
        <div className="password-incorrect-img-div">
          <img
            src={passwordIncorrectImg}
            alt="audio-location-permissions-img"
          />
        </div>
        <Typography className="grant-permissions-steps-dialog-heading">
          {t("you_havent_allowed_access_to_location_mic")}
        </Typography>

        <Typography className="give-permission-do-the-following-typo">
          {t("give_permission_do_the_following")}
        </Typography>

        <List dense>
          <ListItem>
            <ListItemText
              className="grant-permissions-list-item-text"
              primary={
                <>
                  1. {t("open_phone_settings")}{" "}
                  <SettingsIcon
                    fontSize="small"
                    className="grant-permissions-icons"
                  />
                </>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemText
              className="grant-permissions-list-item-text"
              primary={`2. ‘Privacy’  ${t("tap")} > ‘Permission Manager’ ${t("tap")} >`}
            />
          </ListItem>

          <ListItem sx={{ pl: 4 }}>
            <ListItemText
              className="grant-permissions-list-item-text"
              primary={
                <>
                  a. Location{" "}
                  <LocationOnIcon
                    fontSize="small"
                    className="grant-permissions-icons"
                  />{" "}
                  {">"} NIPUN Haryana Teacher App{" "}
                  <img
                    src={nipunHrLogo}
                    alt="nipun-hr-app-logo"
                    className="nipun-hr-app-logo"
                  />
                  {">"} ‘Allow only while using the app’ {t("tap")}.
                </>
              }
            />
          </ListItem>

          <ListItem sx={{ pl: 4 }}>
            <ListItemText
              className="grant-permissions-list-item-text"
              primary={
                <>
                  b. Microphone{" "}
                  <MicIcon
                    fontSize="small"
                    className="grant-permissions-icons"
                  />{" "}
                  {">"} NIPUN Haryana Teacher App{" "}
                  <img
                    src={nipunHrLogo}
                    alt="nipun-hr-app-logo"
                    className="nipun-hr-app-logo"
                  />
                  {">"} ‘Allow only while using the app’ {t("tap")}.
                </>
              }
            />
          </ListItem>
        </List>

        <Button
          variant="contained"
          className="grant-permissions-dialog-button btn-primary"
          disableElevation
          onClick={onClick}
        >
          {t("retry")}
        </Button>
      </DialogTitle>
    </Dialog>
  );
}

export default GrantPermissionsStepsDialog;
